import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class PaymentCheckoutComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/payment-checkout";
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/payment-checkout/;
  }
}
